import { SORT_ITEMS } from "app/pages/activation/components/Topics/constants";
import { ZERO } from "app/pages/activation/components/Topics/Topic/constants";
import type { NormalizedTopicSchema } from "app/pages/activation/components/Topics/types";
import { TopicSorting, TopicFilters } from "app/pages/activation/components/Topics/types";

export const sortTopics = (sorting: TopicSorting) => (a: NormalizedTopicSchema, b: NormalizedTopicSchema) => {
    const current = SORT_ITEMS.find((item) => item.id === sorting);

    switch (sorting) {
        case TopicSorting.Name:
            return a.name.localeCompare(b.name);
        case TopicSorting.MostRecent:
            return b.created.getTime() - a.created.getTime();
        case TopicSorting.ShareChange:
        case TopicSorting.ShareOfVoice:
        case TopicSorting.Vol:
            return b[current.field] - a[current.field];
        default:
            return 0;
    }
};

export const filterTopics = (filter: TopicFilters, sortedTopics: NormalizedTopicSchema[]) => {
    switch (filter) {
        case TopicFilters.Inc:
            return sortedTopics.filter((item) => item.shareOfVoiceChange > ZERO);
        case TopicFilters.Dec:
            return sortedTopics.filter((item) => item.shareOfVoiceChange < ZERO);
        case TopicFilters.Lead:
            return sortedTopics.filter(
                (item) => item.shareOfVoice >= item.leaderShareOfVoice && item.shareOfVoice > ZERO,
            );
        default:
            return sortedTopics;
    }
};
// Returns TRUE if any filter is not applicable
export const getFilterDisabledFlags = (sortedData: NormalizedTopicSchema[]) =>
    sortedData.reduce(
        (acc, item) => {
            if (item.shareOfVoiceChange > ZERO) {acc.inc = false;}
            if (item.shareOfVoiceChange < ZERO) {acc.dec = false;}
            if (item.leaderName === item.primaryName && !!item.leaderShareOfVoice) {acc.lead = false;}
            return acc;
        },
        { inc: true, dec: true, lead: true, all: false },
    );
